module.exports = __webpack_public_path__ + "img/pick2.237f71b2.png";